import * as Yup from "yup";
import {
  requiredText,
  // requiredTextWithZeroToHundred,
} from "@/services/schemas/genericSchemas";

export const InitialValues = {
  fieldName: "",
  fieldType: "",
  fieldSubType: "",
  description: "",
  isImportant: false,
  leadCustomOptions: [{ value: "" }],
};

export const formSchema = Yup.object().shape({
  fieldName: requiredText.trim(),
  fieldType: requiredText,
  fieldSubType: requiredText,
  leadCustomOptions: Yup.array().test({
    name: "unique-lead-custom-options",
    test: (options, { createError, resolve, path }) => {
      const fieldType = String(resolve(Yup.ref("fieldType")) ?? "");
      if (fieldType !== "4" && fieldType !== "5") {
        return true;
      }

      const errors = [];
      const seen = new Map();

      (options || []).forEach((item, index) => {
        const propertyValue = String(item?.value ?? "").trim();
        if (!propertyValue) {
          errors.push(
            createError({
              path: `${path}[${index}]`,
              message: "Option cannot be empty.",
            })
          );
          return;
        }

        const normalized = propertyValue.toLowerCase();
        if (seen.has(normalized)) {
          errors.push(
            createError({
              path: `${path}[${index}]`,
              message: "This option already exists.",
            })
          );
          return;
        }

        seen.set(normalized, index);
      });

      if (errors.length) {
        throw new Yup.ValidationError(errors);
      }

      return true;
    },
  }),
});
